<mat-card class="buy-sell-plan-details">
    <mat-card-title>
        <h6 appLocalizationPopupDirective localizationCode="BuySellRequestDetails">
            {{ 'BuySellRequestDetails' | translate: {Default: "Buy/Sell Request Details"} }}
        </h6>
    </mat-card-title>
    
    <mat-card-content>
        <div class="detail-row">
            <div class="label" appLocalizationPopupDirective localizationCode="BuySellApprovalStatus">{{ 'BuySellApprovalStatus' | translate: {Default: "Status"} }}</div>
            <div class="value">
                <mat-chip-list *ngIf="buySellPlanEmployee">
                    <mat-chip [ngClass]="getStatusChipClass()">
                    {{ buySellPlanEmployee.status?.name }}
                    </mat-chip>
                </mat-chip-list>
            </div>
        </div>

        <div class="detail-row">
            <div class="label" appLocalizationPopupDirective localizationCode="BuySellRequestType">{{ 'BuySellRequestType' | translate: {Default: "Request Type"} }}</div>
            <div class="value">
                {{ selectedType === 'BUY' ? 'Buy' : 'Sell' }}
            </div>
        </div>

        <div class="detail-row">
            <div class="label" appLocalizationPopupDirective localizationCode="BuySellRequestedHours">{{ 'BuySellRequestedHours' | translate: {Default: "Requested Hours"} }}</div>
            <div class="value">
                {{ buySellPlanEmployee?.hours }}
            </div>
        </div>

        <div class="detail-row">
            <div class="label" appLocalizationPopupDirective localizationCode="BuySellHourlyRate">{{ 'BuySellHourlyRate' | translate: {Default: "Hourly Rate"} }}</div>
            <div class="value">
                {{ compensation?.payRateCurrency?.id | currencyDisplay: buySellPlanEmployee?.hourlyCost }}
            </div>
        </div>

        <div class="detail-row">
            <div *ngIf="selectedType === 'BUY'" class="label" appLocalizationPopupDirective localizationCode="SalaryDeduction">
                {{ 'SalaryDeduction' | translate: {Default: "Salary Deduction"} }}
            </div>
            <div *ngIf="selectedType === 'SELL'" class="label" appLocalizationPopupDirective localizationCode="SalaryAddition">
                {{ 'SalaryAddition' | translate: {Default: "Salary Addition"} }}
            </div>
            <div class="value">
                {{ compensation?.payRateCurrency?.id | currencyDisplay: buySellPlanEmployee?.hours * buySellPlanEmployee?.hourlyCost }}
            </div>
        </div>
    </mat-card-content>
</mat-card>